import { Direction } from '@mui/material/styles'

import { TransformProps } from './types'

export const reverseArrowIconDirectionForRtl = ({
    iconDirection,
    themeDirection,
}: {
    iconDirection: TransformProps
    themeDirection: Direction
}): TransformProps => {
    if (iconDirection === 'up' || iconDirection === 'down' || themeDirection === 'ltr') {
        return iconDirection
    }

    return iconDirection === 'left' ? 'right' : 'left'
}
